// @ts-nocheck
import { tsValueToJsonValueFns, jsonValueToTsValueFns, } from "../../../runtime/json/scalar";
import { default as serialize, } from "../../../runtime/wire/serialize";
import { tsValueToWireValueFns, wireValueToTsValueFns, } from "../../../runtime/wire/scalar";
import { default as deserialize, } from "../../../runtime/wire/deserialize";
export function getDefaultValue() {
    return {
        key: "",
        value: "",
    };
}
export function createValue(partialValue) {
    return {
        ...getDefaultValue(),
        ...partialValue,
    };
}
export function encodeJson(value) {
    const result = {};
    if (value.key !== undefined)
        result.key = tsValueToJsonValueFns.string(value.key);
    if (value.value !== undefined)
        result.value = tsValueToJsonValueFns.string(value.value);
    return result;
}
export function decodeJson(value) {
    const result = getDefaultValue();
    if (value.key !== undefined)
        result.key = jsonValueToTsValueFns.string(value.key);
    if (value.value !== undefined)
        result.value = jsonValueToTsValueFns.string(value.value);
    return result;
}
export function encodeBinary(value) {
    const result = [];
    if (value.key !== undefined) {
        const tsValue = value.key;
        result.push([1, tsValueToWireValueFns.string(tsValue)]);
    }
    if (value.value !== undefined) {
        const tsValue = value.value;
        result.push([2, tsValueToWireValueFns.string(tsValue)]);
    }
    return serialize(result);
}
export function decodeBinary(binary) {
    const result = getDefaultValue();
    const wireMessage = deserialize(binary);
    const wireFields = new Map(wireMessage);
    field: {
        const wireValue = wireFields.get(1);
        if (wireValue === undefined)
            break field;
        const value = wireValueToTsValueFns.string(wireValue);
        if (value === undefined)
            break field;
        result.key = value;
    }
    field: {
        const wireValue = wireFields.get(2);
        if (wireValue === undefined)
            break field;
        const value = wireValueToTsValueFns.string(wireValue);
        if (value === undefined)
            break field;
        result.value = value;
    }
    return result;
}
